<template>
  <div>
    <div class="">
      <!-- el版 -->
      <el-form :inline="true" :model="queryParams" class="ant-advanced-search-form">
        <el-form-item label="训练任务">
          <el-select v-model="queryParams.drillId" placeholder="请选择训练任务">
            <el-option :label="item.label" :value="item.value" :key="index"
              v-for="(item, index) in drillPlan"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="运动设备">
          <el-select v-model="queryParams.deviceId" placeholder="请选择运动设备">
            <el-option :label="item.label" :value="item.value" :key="index"
              v-for="(item, index) in deviceList"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="运动日期">
          <el-date-picker v-model="queryParams.time" type="daterange" range-separator="至" start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="handleQuery" icon="el-icon-search">查询</el-button>
          <el-button type="" @click="handleReset" icon="el-icon-refresh">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="wz-mt-2">
      <!-- 数据列表 -->
      <el-table element-loading-text="加载中" :data="list" border style="width: 100%">
        <el-table-column label="运动日期" align="center" prop="drillDate" />
        <el-table-column label="使用设备" align="center" prop="deviceName" />
        <el-table-column label="操作" align="center" width="250">
          <template slot-scope="scope">
            <div class="">
              <el-button size="small" plain type="primary" @click="goInfo(scope.row)">详情</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <pagination :total="pagination.total" :page.sync="pagination.current" :limit.sync="pagination.pageSize"
        @pagination="getList" />
    </div>

    <a-modal centered width="60%" :footer="null" :title="modalTitle" class="detail_modal" :visible="modalShow"
      @cancel="modalShow = false">
      <div class="modal_content chart_modal_content">
        <!-- 弹窗用户信息 -->
        <div class="data_userInfo">
          <div class="user">
            <div class="avatar">
              <img :src="currentDevice.sportsManPhoto" alt="" />
            </div>
            <div class="name">{{ currentDevice.sportsManName }}</div>
          </div>
          <div class="base">
            <div class="row_th">
              <div class="odd">
                <label>设备名称：</label>
                <span>{{ baseInfo.name }}</span>
              </div>
              <div class="odd">
                <label>MAC编码：</label>
                <span>{{ baseInfo.mac }}</span>
              </div>
            </div>
            <div class="row_th">
              <div class="odd">
                <label>训练计划：</label>
                <span>{{ baseInfo.drillName }}</span>
              </div>
              <div class="odd">
                <label>使用时间：</label>
                <span>{{ baseInfo.startTime }}</span>
              </div>
            </div>
          </div>
          <div class="date_bored" :class="{ done: baseInfo.status == 3 }">
            <div class="sut">
              {{ baseInfo.status == 2 ? "运动中" : "已结束" }}
            </div>
            <div class="time" v-if="baseInfo.status == 2 || baseInfo.status == 3">
              {{ baseInfo.timeText }}
            </div>
          </div>
        </div>
        {{ currentDevice.category }}
        <!-- CORE(echart 7-8) -->
        <div v-if="currentDevice.category == 1">
          <div v-if="bodyTemp.YData && bodyTemp.YData.length > 0">
            <div class="other_data mt-24 bg_gray" v-if="bodyTemp.YData && bodyTemp.YData.length > 0">
              <div class="data_echart mt-10 flex-c-c">
                <LineEchart :echartId="'chart7'" :title="bodyTemp.title" :xData="bodyTemp.xData" :yData="bodyTemp.YData"
                  :yName="bodyTemp.yName" />
              </div>
            </div>
            <div class="other_data mt-24">
              <div class="temBar color flex-row align-center p-10">
                <span class="mr-20">{{ coreStat.highAlarmName }}</span>
                <div class="flex-1 mr-20">
                  <a-progress :percent="toNum(coreStat.highAlarmRate)"
                    strokeColor="linear-gradient(90deg,#e8ac63, #e77743 81%)" :strokeWidth="8" :showInfo="false"
                    trailColor="#141937" />
                </div>
                <span class="mr-20">{{ coreStat.highAlarmRate }}%</span>
                <span>{{ coreStat.highAlarmMin }}min</span>
              </div>
              <div class="temBar color flex-row align-center p-10 mt-15">
                <span class="mr-20">{{ coreStat.heatTrainingName }}</span>
                <div class="flex-1 mr-20">
                  <a-progress :percent="toNum(coreStat.heatTrainingRate)"
                    strokeColor="linear-gradient(90deg,#e8ac63, #e77743 81%)" :strokeWidth="8" :showInfo="false"
                    trailColor="#141937" />
                </div>
                <span class="mr-20">{{ coreStat.heatTrainingRate }}%</span>
                <span>{{ coreStat.heatTrainingMin }}min</span>
              </div>
              <div class="temBar color flex-row align-center p-10 mt-15">
                <span class="mr-20">{{ coreStat.trainingAreaName }}</span>
                <div class="flex-1 mr-20">
                  <a-progress :percent="toNum(coreStat.trainingAreaRate)"
                    strokeColor="linear-gradient(90deg,#e8ac63, #e77743 81%)" :strokeWidth="8" :showInfo="false"
                    trailColor="#141937" />
                </div>
                <span class="mr-20">{{ coreStat.trainingAreaRate }}%</span>
                <span>{{ coreStat.trainingAreaMin }}min</span>
              </div>
              <div class="temBar color flex-row align-center p-10 mt-15">
                <span class="mr-20">{{ coreStat.centreLevelName }}</span>
                <div class="flex-1 mr-20">
                  <a-progress :percent="toNum(coreStat.centreLevelRate)"
                    strokeColor="linear-gradient(90deg,#e8ac63, #e77743 81%)" :strokeWidth="8" :showInfo="false"
                    trailColor="#141937" />
                </div>
                <span class="mr-20">{{ coreStat.centreLevelRate }}%</span>
                <span>{{ coreStat.centreLevelMin }}min</span>
              </div>
              <div class="temBar color flex-row align-center p-10 mt-15">
                <span class="mr-20">{{ coreStat.lowLevelName }}</span>
                <div class="flex-1 mr-20">
                  <a-progress :percent="toNum(coreStat.lowLevelRate)"
                    strokeColor="linear-gradient(90deg,#e8ac63, #e77743 81%)" :strokeWidth="8" :showInfo="false"
                    trailColor="#141937" />
                </div>
                <span class="mr-20">{{ coreStat.lowLevelRate }}%</span>
                <span>{{ coreStat.lowLevelMin }}min</span>
              </div>
              <div class="temBar color flex-row align-center p-10 mt-15">
                <span class="mr-20">{{ coreStat.hypothermyName }}</span>
                <div class="flex-1 mr-20">
                  <a-progress :percent="toNum(coreStat.hypothermyRate)"
                    strokeColor="linear-gradient(90deg,#e8ac63, #e77743 81%)" :strokeWidth="8" :showInfo="false"
                    trailColor="#141937" />
                </div>
                <span class="mr-20">{{ coreStat.hypothermyRate }}%</span>
                <span>{{ coreStat.hypothermyMin }}min</span>
              </div>
            </div>

            <div class="other_data mt-24 color">
              <div class="header">热训练</div>
              <div class="p-20">
                <div>总计{{ coreStat.heatTrainingMin }}min (以分钟为单位)</div>
              </div>
              <div class="field flex-1">
                <a-slider :min="0" :max="toNum(coreStat.heatTrainingTime)" disabled
                  :marks="getMarks(coreStat.heatTrainingTime)" :value="toNum(coreStat.heatTrainingMin)" />
              </div>
            </div>

            <div class="other_data mt-24 bg_gray" v-if="skinTemp.YData && skinTemp.YData.length > 0">
              <div class="data_echart mt-10 flex-c-c">
                <LineEchart :echartId="'chart8'" :title="skinTemp.title" :xData="skinTemp.xData" :yData="skinTemp.YData"
                  :yName="skinTemp.yName" />
              </div>
            </div>
          </div>

          <a-empty v-else />
        </div>

        <!-- 背心(echart 9-11) -->
        <div v-if="currentDevice.category == 2">
          <div v-if="heartRate.YData && heartRate.YData.length > 0">
            <div class="other_data mt-24 bg_gray" v-if="heartRate.YData && heartRate.YData.length > 0">
              <div class="data_echart mt-10 flex-c-c">
                <LineEchart :echartId="'chart9'" :title="heartRate.title" :xData="heartRate.xData"
                  :yData="heartRate.YData" :yName="heartRate.yName" />
              </div>
            </div>
            <div class="other_data mt-24 bg_gray" v-if="respiratory.YData && respiratory.YData.length > 0">
              <div class="data_echart mt-10 flex-c-c">
                <LineEchart :echartId="'chart10'" :title="respiratory.title" :xData="respiratory.xData"
                  :yData="respiratory.YData" :yName="respiratory.yName" />
              </div>
            </div>
            <div class="other_data mt-24 bg_gray" v-if="breathe.YData && breathe.YData.length > 0">
              <div class="data_echart mt-10 flex-c-c">
                <div class="chart_y_name">
                  <p>
                    最小呼气{{ breathe.minInhale }}rpm 最大呼气{{
                    breathe.maxInhale
                    }}rpm
                  </p>
                  <p>
                    最小吸气{{ breathe.minExpiration }}rpm 最大吸气{{
                    breathe.maxExpiration
                    }}rpm
                  </p>
                </div>
                <LineEchart :echartId="'chart11'" :title="breathe.title" :xData="breathe.xData" :yData="breathe.YData"
                  :yName="breathe.yName" :yDataMore="true" />
              </div>
            </div>
          </div>

          <a-empty v-else />
        </div>

        <!-- 铁人(echart 1-6) -->
        <div v-if="currentDevice.category == 3">
          <div v-if="chartArr && chartArr.length > 0">
            <div class="flex-row justify-around mt-24 exciting_total_list">
              <div class="flex-column align-center justify-center exciting_total_item"
                :style="`background-image: url(${modal_bg.green})`">
                <span class="exciting_num">{{ ironManOneVo.calories }}</span>
                <span class="exciting_dw">消耗(千卡)</span>
              </div>
              <div class="flex-column align-center justify-center exciting_total_item"
                :style="`background-image: url(${modal_bg.orange})`">
                <span class="exciting_num">{{ ironManOneVo.time }}</span>
                <span class="exciting_dw">时长(分钟)</span>
              </div>
              <div class="flex-column align-center justify-center exciting_total_item"
                :style="`background-image: url(${modal_bg.blue})`">
                <span class="exciting_num">{{ ironManOneVo.mileage }}</span>
                <span class="exciting_dw">里程(公里)</span>
              </div>
            </div>
            <div class="other_data mt-24">
              <div class="header">峰值数据</div>
              <div class="data_table mt-10 color">
                <div class="flex-row justify-between align-center p-20 bg_color">
                  <span>最大功率</span>
                  <span>{{ peakData.maxPower }}w</span>
                </div>
                <div class="flex-row justify-between align-center p-20">
                  <span>最大心率</span>
                  <span>{{ peakData.maxHeart }}bpm</span>
                </div>
                <div class="flex-row justify-between align-center p-20 bg_color">
                  <span>最大向心速度</span>
                  <span>{{ peakData.maxToSpeed }}m/s</span>
                </div>
                <div class="flex-row justify-between align-center p-20">
                  <span>最大向心加速度</span>
                  <span>{{ peakData.maxToAcc }}m/s²</span>
                </div>
                <div class="flex-row justify-between align-center p-20 bg_color">
                  <span>最大离心速度</span>
                  <span>{{ peakData.maxFroSpeed }}m/s</span>
                </div>
                <div class="flex-row justify-between align-center p-20">
                  <span>最大离心加速度</span>
                  <span>{{ peakData.maxFroAcc }}m/s²</span>
                </div>
              </div>
            </div>
            <div class="other_data mt-24">
              <div class="header">平均数据</div>
              <div class="data_table mt-10 color">
                <div class="flex-row justify-between align-center p-20 bg_color">
                  <span>平均功率</span>
                  <span>{{ avgData.avgPower }}w</span>
                </div>
                <div class="flex-row justify-between align-center p-20">
                  <span>平均心率</span>
                  <span>{{ avgData.avgHeart }}bpm</span>
                </div>
                <div class="flex-row justify-between align-center p-20 bg_color">
                  <span>平均离心速度</span>
                  <span>{{ avgData.avgFroSpeed }}m/s</span>
                </div>
                <div class="flex-row justify-between align-center p-20">
                  <span>平均离心加速度</span>
                  <span>{{ avgData.avgFroAcc }}m/s²</span>
                </div>
                <div class="flex-row justify-between align-center p-20 bg_color">
                  <span>平均向心速度</span>
                  <span>{{ avgData.avgToSpeed }}m/s</span>
                </div>
                <div class="flex-row justify-between align-center p-20">
                  <span>平均向心加速度</span>
                  <span>{{ avgData.avgToAcc }}m/s²</span>
                </div>
              </div>
            </div>
            <div class="other_data mt-24 bg_gray">
              <div class="header">运动趋势图</div>
              <div class="data_echart mt-10 flex-c-c" v-for="(item, index) in chartArr" :key="index">
                <LineEchart :echartId="`chart${index}`" :title="item.title" :xData="item.xData" :yData="item.YData"
                  :xName="item.xName" :yName="item.yName" />
              </div>
            </div>
          </div>
          <a-empty v-else />
        </div>

        <!-- 阻尼设备(echart 12-16) -->
        <div v-if="currentDevice.category == 4">
          <div v-if="znRfdDetails.rfdData.list && znRfdDetails.rfdData.list.length">
            <div class="other_data mt-24">
              <div class="data_table mt-10 color">
                <div class="flex-row justify-between align-center p-20 bg_color">
                  <span>最大速度</span>
                  <span>{{
                    trainData.maxSpeed ? trainData.maxSpeed + "m/s" : "--"
                    }}</span>
                </div>
                <div class="flex-row justify-between align-center p-20">
                  <span>最大功率</span>
                  <span>{{
                    trainData.maxPower ? trainData.maxPower + "w" : "--"
                    }}</span>
                </div>
                <div class="flex-row justify-between align-center p-20 bg_color">
                  <span>能量消耗</span>
                  <span>{{
                    trainData.energe ? trainData.energe + "cal" : "--"
                    }}</span>
                </div>
                <div class="flex-row justify-between align-center p-20">
                  <span>最大RFD</span>
                  <span>{{
                    trainData.maxRfd ? trainData.maxRfd + "N/S" : "--"
                    }}</span>
                </div>
                <div class="flex-row justify-between align-center p-20 bg_color">
                  <span>运动耗时</span>
                  <span>{{ trainData.coast ? trainData.coast + "s" : "--"
                    }}{{ trainData.coast || "" }}</span>
                </div>
                <div class="flex-row justify-between align-center p-20">
                  <span>拉动次数</span>
                  <span>{{
                    trainData.countPlan ? trainData.countPlan : "--"
                    }}</span>
                </div>
              </div>
            </div>
            <div class="header mt-20">速度轨迹图</div>
            <div class="other_data mt-24 bg_gray">
              <div class="data_echart mt-10 flex-c-c">
                <div class="chart_y_name">
                  <p>
                    最大向心速度{{ znSpeadDetails.maxSpeedIn || "--" }}m/s
                    平均向心速度{{ znSpeadDetails.avgSpeedIn || "--" }}m/s
                  </p>
                  <p>
                    最大离心速度{{ znSpeadDetails.maxSpeedOut || "--" }}m/s
                    平均离心速度{{ znSpeadDetails.avgSpeedOut || "--" }}m/s
                  </p>
                </div>
                <LineEchart :echartId="'chart12'" :title="znSpeadDetails.title" :xData="znSpeadDetails.speadData.time"
                  :yData="znSpeadDetails.speadData.list" />
              </div>
            </div>
            <div class="header mt-20">功率轨迹图</div>
            <div class="other_data mt-24 bg_gray">
              <div class="data_echart mt-10 flex-c-c">
                <div class="chart_y_name">
                  <p>
                    最大功率{{ znPowerDetails.maxPower || "--" }}w 平均功率{{
                    znPowerDetails.avgPower || "--"
                    }}w
                  </p>
                </div>
                <LineEchart :echartId="'chart13'" :title="znPowerDetails.title" :xData="znPowerDetails.powerData.time"
                  :yData="znPowerDetails.powerData.list" />
              </div>
            </div>
            <div class="header mt-20">能量消耗轨迹图</div>
            <div class="other_data mt-24 bg_gray">
              <div class="data_echart mt-10 flex-c-c">
                <div class="chart_y_name">
                  <p>最大消耗{{ znPowerCostDetails.maxEnerge || "--" }}cal</p>
                </div>
                <LineEchart :echartId="'chart14'" :title="znPowerCostDetails.title"
                  :xData="znPowerCostDetails.energeData.time" :yData="znPowerCostDetails.energeData.list" />
              </div>
            </div>
            <div class="header mt-20">RFD轨迹图</div>
            <div class="other_data mt-24 bg_gray">
              <div class="data_echart mt-10 flex-c-c">
                <div class="chart_y_name">
                  <p>最大RFD{{ znRfdDetails.maxRfd || "--" }}N/S</p>
                </div>
                <LineEchart :echartId="'chart15'" :title="znRfdDetails.title" :xData="znRfdDetails.rfdData.time"
                  :yData="znRfdDetails.rfdData.list" />
              </div>
            </div>
            <div class="header mt-20">耗时区间图</div>
            <div class="other_data mt-24 bg_gray">
              <div class="data_echart mt-10 flex-c-c">
                <cakeEchart :echartId="'chart16'" :yData="znSpendTime.data" />
              </div>
            </div>
            <div class="header mt-20">汇总数据</div>
            <a-table class="zebra-table mt-10" :dataSource="statData" :columns="statColumns" :pagination="false"
              :rowClassName="(record, index) => (index % 2 === 1 ? 'table-striped' : null)
        ">
              <template #type="{ record }">
                <span v-if="record.type == 'power'">功率(W)</span>
                <span v-if="record.type == 'pull'">力量(kg)</span>
                <span v-if="record.type == 'speed'">速度(m/s)</span>
                <span v-if="record.type == 'pos'">位移(m)</span>
                <span v-if="record.type == 'rfd'">RFD(N/S)</span>
                <span v-if="record.type == 'energe'">能量消耗(cal)</span>
                <span v-if="record.type == 'coast'">运动耗时(s)</span>
                <span v-if="record.type == 'count'">运动次数</span>
              </template>
              <template #inVal="{ record }">
                {{ record.inVal || "--" }}
              </template>
              <template #outVal="{ record }">
                {{ record.outVal || "--" }}
              </template>
              <template #maxVal="{ record }">
                {{ record.maxVal || "--" }}
              </template>
              <template #avgVal="{ record }">
                {{ record.avgVal || "--" }}
              </template>
              <template #allVal="{ record }">
                {{ record.allVal || "--" }}
              </template>
            </a-table>
          </div>
          <a-empty v-else />
        </div>
      </div>
    </a-modal>
    
    <!-- 新弹窗 -->
    <el-dialog width="60%" class="devicePanel" :visible.sync="previewShow" append-to-body :title="modalTitle">
      <div class="data_userInfo">
        <div class="user">
          <div class="avatar">
            <el-avatar :src="currentDevice.sportsManPhoto"></el-avatar>
          </div>
          <div class="name">{{ currentDevice.sportsManName }}</div>
        </div>
        <div class="base">
          <div class="row_th">
            <div class="odd">
              <label>设备名称：</label>
              <span>{{ baseInfo.deviceName }}</span>
            </div>
            <div class="odd">
              <label>MAC编码：</label>
              <span>{{ baseInfo.mac }}</span>
            </div>
          </div>
          <div class="row_th">
            <div class="odd">
              <label>训练计划：</label>
              <span>{{ baseInfo.drillName || '--' }}</span>
            </div>
            <div class="odd">
              <label>使用时间：</label>
              <span>{{ moment(baseInfo.startTime).format('YYYY-MM-DD hh:mm:ss') }}</span>
            </div>
          </div>
        </div>
        <div class="date_bored" :class="{ done: baseInfo.status == 3 }">
          <div class="sut">
            {{ baseInfo.status == 2 ? "运动中" : "已结束" }}
          </div>
          <div class="time" v-if="baseInfo.status == 2 || baseInfo.status == 3">
            {{ baseInfo.timeText }}
          </div>
        </div>
      </div>
      <Preview :pid="panelId" :filter="panelFilter" v-if="previewShow"/>
    </el-dialog>
  </div>
</template>
<script>
import moment from "moment";
import Preview from "@/views/system/preview/index";
import { message } from "ant-design-vue";
import * as API_Member from "@/api/member/member";
import LineEchart from "../../../../workBench/components/LineEchart.vue";
import cakeEchart from "../../../../workBench/components/cakeEchart";
import { getNowCanvasComponentData } from "@/components/canvas/utils/utils";

export default {
  inject: ["getId"],
  computed: {
    id() {
      return this.getId();
    },
    changeTime() {
      return function (time, type) {
        type = type ? type : "YYYY-MM-DD HH:mm:ss";
        if (!time) {
          return "";
        }
        if (type == "week") {
          let num = moment(time).weekday();
          num =
            num == 0
              ? "周一"
              : num == 1
                ? "周二"
                : num == 2
                  ? "周三"
                  : num == 3
                    ? "周四"
                    : num == 4
                      ? "周五"
                      : num == 5
                        ? "周六"
                        : "周日";
          return num;
        } else {
          return moment(time).format(type);
        }
      };
    },
    getTimeFrame() {
      let drillTime = [
        { key: 1, value: "早操", }, 
        { key: 2, value: "上午", }, 
        { key: 3, value: "下午", }, 
        { key: 4, value: "晚上", },
      ];
      return function (num) {
        if (num != "" && drillTime.filter((res) => res.key == num)) {
          return drillTime.filter((res) => res.key == num)[0].value;
        } else {
          return "";
        }
      };
    },
    getTimeType() {
      let drillTypeList = [
        { key: "1", value: "基础力量", }, 
        { key: "2", value: "复合式力量", }, 
        { key: "3", value: "爆发力", }, 
        { key: "4", value: "基础有氧", }, 
        { key: "5", value: "高强度间歇", }, 
        { key: "6", value: "功能训练", }, 
        { key: "7", value: "速度训练", }, 
        { key: "8", value: "协调灵敏", },
      ];
      return function (type) {
        if (
          type != "" &&
          drillTypeList.filter((res) => res.key == type).length
        ) {
          return drillTypeList.filter((res) => res.key == type)[0].value;
        } else {
          return "";
        }
      };
    },
    toNum() {
      return (num) => {
        return Number(num);
      };
    },
    getMarks() {
      return (max) => {
        return {
          0: "0",
          [max]: max,
        };
      };
    },
  },
  components: {
    LineEchart,
    cakeEchart, Preview,
  },
  data() {
    return {
      Time: null,
      baseInfo: {},
      columns: [
        {
          title: "运动日期",
          align: "center",
          dataIndex: "drillDate",
          key: "drillDate",
        },
        // {
        //   title: "运动时间",
        //   align: "center",
        //   dataIndex: "startTime",
        //   key: "startTime",
        //   customRender: (e) => {
        //     let item = this.list[e.index];
        //     let str = "";
        //     if(item.startTime && item.endTime) {
        //       str = moment(item.startTime).format("HH:mm") +'-'+moment(item.endTime).format("HH:mm")
        //     }
        //     if(!item.endTime) {
        //       str = item.startTime ? moment(item.startTime).format("HH:mm") : "";
        //     }
        //     return str;
        //   },
        // },
        // {
        //   title: "训练任务",
        //   align: "center",
        //   dataIndex: "drillName",
        //   key: "drillName",
        // },
        {
          title: "使用设备",
          align: "center",
          dataIndex: "deviceName",
          key: "deviceName",
        },
        // {
        //   title: "使用状态",
        //   align: "center",
        //   dataIndex: "status",
        //   key: "status",
        //   customRender: ({ text }) => {
        //     let obj = {
        //       1: "连接中",
        //       2: "使用中",
        //       3: "已结束",
        //     };
        //     return obj[text];
        //   },
        // },
        {
          title: "操作",
          width: 150,
          dataIndex: "action",
          key: "action",
          fixed: "right",
          align: "center",
          scopedSlots: { customRender: "action" },
        },
      ],
      drillPlan: [],
      deviceList: [],
      list: [],
      pagination: {
        current: 1,
        pageSize: 10,
        total: 100,
        showSizeChanger: true,
        pageSizeOptions: ["10", "20", "30", "40", "50"],
      },
      queryParams: {
        drillId: null,
        deviceId: null,
        time: [],
      },
      showTime: {
        format: "HH:mm:ss",
        defaultValue: [
          moment("00:00:00", "HH:mm:ss"),
          moment("23:59:59", "HH:mm:ss"),
        ],
      },

      modalShow: false,
      modalTitle: "运动数据",
      currentDevice: {},
      coreBodyTemperatureData: {},
      skinTemperatureData: {},
      coreStat: {},
      heartrateTableData: {
        title: "",
        xData: "",
        YData: "",
      },
      chartArr: [],
      peakData: {},
      avgData: {},
      ironManOneVo: {},
      bodyTemp: {},
      skinTemp: {},
      curVal: "",
      heartRate: {}, //心率
      respiratory: {}, //呼吸频次
      breathe: {}, //呼吸量
      trainData: {},
      znSpeadDetails: {
        speadData: {
          time: [],
          list: { data: [] },
        },
      },
      znPowerDetails: {
        powerData: {
          time: [],
          list: [],
        },
      },
      znPowerCostDetails: {
        energeData: {
          time: [],
          list: [],
        },
      },
      znRfdDetails: {
        rfdData: {
          time: [],
          list: [],
        },
      },
      znSpendTime: {
        data: [],
      },
      statData: [],
      statColumns: [
        {
          title: "指标/峰值",
          dataIndex: "type",
          key: "type",
          width: 200,
          slots: { customRender: "type" },
        },
        {
          title: "向心累计",
          dataIndex: "inVal",
          key: "inVal",
          slots: { customRender: "inVal" },
        },
        {
          title: "离心累计",
          dataIndex: "outVal",
          key: "outVal",
          slots: { customRender: "outVal" },
        },
        {
          title: "最大",
          dataIndex: "maxVal",
          key: "maxVal",
          slots: { customRender: "maxVal" },
        },
        {
          title: "平均",
          dataIndex: "avgVal",
          key: "avgVal",
          slots: { customRender: "avgVal" },
        },
        {
          title: "累计",
          dataIndex: "allVal",
          key: "allVal",
          slots: { customRender: "allVal" },
        },
      ],
      // 新弹窗
      previewShow: false,
      panelId: null,
      panelFilter: null,
      mainHeight: '300px !important'
    };
  },
  mounted() {
    console.log(this.info);
    this.getList();
    this.getPlan();
    this.getDeviceList();
  },
  methods: {
    moment,
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.getList();
    },
    handleReset() {
      this.queryParams.drillId = "";
      this.queryParams.deviceId = "";
      this.queryParams.time = [];
      this.handleQuery();
    },
    // 切换分页
    changePage(e) {
      this.pagination.current = e.current;
      this.getList();
    },
    // --任务下拉列表
    getPlan() {
      API_Member.getDrillPlan({ userId: this.id }).then((res) => {
        // console.log(res);
        this.drillPlan = res.data.map((i) => {
          return {
            value: i.drillId,
            label: i.drillName,
          };
        });
        // console.log(this.drillPlan);
      });
    },
    // --设备下拉列表
    getDeviceList() {
      API_Member.getDeviceList({ userId: this.id }).then((res) => {
        // console.log(res);
        this.deviceList = res.data.map((i) => {
          return {
            value: i.id,
            label: i.name,
          };
        });
        // console.log(this.deviceList);
      });
    },
    // --运动记录列表
    getList() {
      API_Member.sportRecord({
        memberId: this.id,
        pageNum: this.pagination.current,
        pageSize: this.pagination.pageSize,
        startTime:
          (this.queryParams.time.length &&
            moment(this.queryParams.time[0]).valueOf()) ||
          "",
        endTime:
          (this.queryParams.time.length &&
            moment(this.queryParams.time[1]).valueOf()) ||
          "",
        ...this.queryParams,
      }).then((res) => {
        console.log(res);
        this.list = res.data.list;
        this.pagination.total = res.data.total;
      });
    },
    goInfo(item) {
      console.log("详情--", item);
      // this.previewShow = true
      this.currentDevice = item;
      this.getDevicePanel(item)
      this.getDrillRecordInfo(item);
      // if (item.category == 1) {
      //   this.coreDrillData(item.id);
      // }
      // if (item.category == 2) {
      //   this.getUnderwaist(item.id);
      // }
      // if (item.category == 3) {
      //   this.getTRData(item);
      //   this.getTRChartsData(item);
      // }
      // if (item.category == 4) {
      //   this.znData(item);
      // }
    },
    // 通过设备id获取模型id
    getDevicePanel(e) {
      let param = {
        deviceId: e.deviceId,
      };
      API_Member.getDevicePanel(param).then((res) => {
        console.log(res);
        if(res.data) {
          this.panelId = res.data
          let obj = {
            userId: this.id,
            deviceRecordId: e.id,
          }
          this.panelFilter = btoa(JSON.stringify(obj))
          console.log(this.panelId);
          console.log(this.panelFilter);
          this.previewShow = true
        } else {
          this.$message({
            message: "暂无数据",
            type: "error",
          });
        }
      });
    },

    // --设备详情
    getDrillRecordInfo(e) {
      let param = {
        userId: this.memberId,
        deviceRecordId: e.id,
      };  
      API_Member.getDrillRecordInfo(param).then((res) => {
        this.baseInfo = res.data;
        if (this.baseInfo.status == 3) {
          this.baseInfo.timeText = this.shotTimes(
            this.baseInfo.endTime - this.baseInfo.startTime
          );
        } else {
          this.timeCount();
        }
      });
    },
    timeCount() {
      this.Time = setInterval(() => {
        this.repeat();
      }, 1000);
    },
    // 弹窗倒计时
    shotTimes(msec) {
      const hour = Math.floor(msec / 1000 / 60 / 60); // 小时
      const min = Math.floor(msec / 1000 / 60) % 60; // 分钟
      const sec = Math.floor(msec / 1000) % 60; // 秒
      return `${this.padStart(hour)}:${this.padStart(min)}:${this.padStart(
        sec
      )}`;
    },
    padStart(str) {
      return str.toString().padStart(2, "0");
    },
    repeat() {
      const now = +new Date();
      const msec = now - this.baseInfo.startTime; // 毫秒
      const hour = Math.floor(msec / 1000 / 60 / 60); // 小时
      const min = Math.floor(msec / 1000 / 60) % 60; // 分钟
      const sec = Math.floor(msec / 1000) % 60; // 秒
      console.log(
        this.padStart(hour) +
        ":" +
        this.padStart(min) +
        ":" +
        this.padStart(sec)
      );
      this.baseInfo.timeText =
        this.padStart(hour) +
        ":" +
        this.padStart(min) +
        ":" +
        this.padStart(sec);
      // this.setData({
      //   'deviceInfo.timeText': `${this.padStart(hour)}:${this.padStart(min)}:${this.padStart(sec)}`
      // })
    },

    cancelCloseModal() {
      console.log("关闭了");
      clearInterval(this.Time);
      this.Time = null;
    },
    // --core设备训练数据
    coreDrillData(id) {
      API_Member.coreDrillData({
        deviceRecordId: id,
      }).then((res) => {
        if (res.code == 200) {
          console.log("res.data", res.data);
          const { coreBodyTemperatureData, coreStat, skinTemperatureData } =
            res.data;
          console.log(coreBodyTemperatureData.list[0]);
          coreBodyTemperatureData.max = coreBodyTemperatureData.list[0]
            ? Math.max(...coreBodyTemperatureData.list[0].data)
            : "";
          coreBodyTemperatureData.min = coreBodyTemperatureData.list[0]
            ? Math.min(...coreBodyTemperatureData.list[0].data)
            : "";
          skinTemperatureData.max = skinTemperatureData.list[0]
            ? Math.max(...skinTemperatureData.list[0].data)
            : "";
          skinTemperatureData.min = skinTemperatureData.list[0]
            ? Math.min(...skinTemperatureData.list[0].data)
            : "";
          this.coreBodyTemperatureData = coreBodyTemperatureData;
          this.coreStat = coreStat;
          this.skinTemperatureData = skinTemperatureData;

          this.bodyTemp = {
            title: "体温(℃)",
            xData: coreBodyTemperatureData.time,
            YData: coreBodyTemperatureData.list[0]
              ? coreBodyTemperatureData.list[0].data
              : [],
            yName: `最低${coreBodyTemperatureData.min}℃ 最高${coreBodyTemperatureData.max}℃`,
          };
          this.skinTemp = {
            title: "皮肤温度(℃)",
            xData: skinTemperatureData.time,
            YData: skinTemperatureData.list[0]
              ? skinTemperatureData.list[0].data
              : [],
            yName: `最低${skinTemperatureData.min}℃ 最高${skinTemperatureData.max}℃`,
          };

          this.modalShow = true;
        }
      });
    },
    // 运动详情-铁人IRAP1509设备训练数据
    getTRData(params) {
      API_Member.ironManData({
        deviceRecordId: params.id,
        deviceId: 11,
        userId: params.memberId,
      }).then((res) => {
        if (res.code == 200) {
          console.log("铁人数据", res.data.ironManOneVo);
          const { peakData, avgData } = res.data.ironManOneVo;
          this.peakData = peakData;
          this.avgData = avgData;
          this.ironManOneVo = res.data.ironManOneVo;
        }
      });
    },
    // 运动详情-铁人IRAP1509设备图表数据
    getTRChartsData(params) {
      API_Member.ironManTableData({
        deviceRecordId: params.id,
        deviceId: 11,
        userId: params.memberId,
      }).then((res) => {
        if (res.code == 200) {
          this.echartsDataList = res.data;
          this.readyEcharts();
        }
      });
    },
    readyEcharts() {
      const {
        heartrateTableData,
        toSpeedTableData,
        froSpeedTableData,
        speedTableData,
        toAccTableData,
        froAccTableData,
      } = this.echartsDataList;
      this.chartArr = [
        {
          title: "心率曲线图",
          xData: heartrateTableData.time,
          YData: heartrateTableData.list[0].data,
          xName: "时间：min",
          yName: "心率：bpm",
        },
        {
          title: "向心速度时间曲线图",
          xData: toSpeedTableData.time,
          YData: toSpeedTableData.list[0].data,
          xName: "时间：min",
          yName: "速度：km",
        },
        {
          title: "离心速度时间曲线图",
          xData: froSpeedTableData.time,
          YData: froSpeedTableData.list[0].data,
          xName: "时间：min",
          yName: "速度：km",
        },
        {
          title: "功率时间曲线图",
          xData: speedTableData.time,
          YData: speedTableData.list[0].data,
          xName: "时间：min",
          yName: "功率：w",
        },
        {
          title: "向心加速度时间曲线图",
          xData: toAccTableData.time,
          YData: toAccTableData.list[0].data,
          xName: "时间：min",
          yName: "加速度：m/s²",
        },
        {
          title: "离心加速度时间曲线图",
          xData: froAccTableData.time,
          YData: froAccTableData.list[0].data,
          xName: "时间：min",
          yName: "加速度：m/s²",
        },
      ];
      // // 心率
      // this.init_chart("#mychart-dom-bar1", initChart, heartrateTableData.time, heartrateTableData.list[0].data);
      // // 向心速度
      // this.init_chart("#mychart-dom-bar2", initChart, toSpeedTableData.time, toSpeedTableData.list[0].data);
      // // 离心速度
      // this.init_chart("#mychart-dom-bar3", initChart, froSpeedTableData.time, froSpeedTableData.list[0].data);
      // // 功率时间
      // this.init_chart("#mychart-dom-bar4", initChart, speedTableData.time, speedTableData.list[0].data);
      // // 向心加速度
      // this.init_chart("#mychart-dom-bar5", initChart, toAccTableData.time, toAccTableData.list[0].data);
      // // 离心加速度
      // this.init_chart("#mychart-dom-bar6", initChart, froAccTableData.time, froAccTableData.list[0].data);

      this.modalShow = true;
    },
    // 背心
    getUnderwaist(id) {
      API_Member.deviceRecordId({
        deviceRecordId: id,
      }).then((res) => {
        console.log(res);

        if (res.code == 200) {
          const {
            hxHeartDataDetails,
            hxBreatheRateDataDetails,
            hxInhaleAndExpirationDataDetails,
          } = res.data;
          //心率
          this.heartRate = {
            title: "心率（bpm）",
            xData: hxHeartDataDetails.hxHeartData
              ? hxHeartDataDetails.hxHeartData.time
              : [],
            YData: hxHeartDataDetails.hxHeartData
              ? hxHeartDataDetails.hxHeartData.list[0].data
              : [],
            yName: `最小${hxHeartDataDetails.minHeart}bpm 最高${hxHeartDataDetails.maxHeart}bpm`,
          };
          //呼吸频率
          this.respiratory = {
            title: "呼吸频次",
            xData: hxBreatheRateDataDetails.hxBreatheRateData
              ? hxBreatheRateDataDetails.hxBreatheRateData.time
              : [],
            YData: hxBreatheRateDataDetails.hxBreatheRateData
              ? hxBreatheRateDataDetails.hxBreatheRateData.list[0].data
              : [],
            yName: `平均频次 ${hxBreatheRateDataDetails.avgFrequency}次/分钟`,
          };
          //呼吸量
          this.breathe = {
            title: "呼吸量（rpm）",
            xData:
              hxInhaleAndExpirationDataDetails.hxInhaleAndExpirationData.time,
            YData:
              hxInhaleAndExpirationDataDetails.hxInhaleAndExpirationData.list,
            maxInhale: Number(
              hxInhaleAndExpirationDataDetails.maxInhale
            ).toFixed(2),
            minInhale: Number(
              hxInhaleAndExpirationDataDetails.minInhale
            ).toFixed(2),
            maxExpiration: Number(
              hxInhaleAndExpirationDataDetails.maxExpiration
            ).toFixed(2),
            minExpiration: Number(
              hxInhaleAndExpirationDataDetails.minExpiration
            ).toFixed(2),
            yName: ``,
          };
          // // 心率
          // this.init_chart("#mychart-dom-bar1", initChart, heartrateTableData.time, heartrateTableData.list[0].data);
          // // 向心速度
          // this.init_chart("#mychart-dom-bar2", initChart, toSpeedTableData.time, toSpeedTableData.list[0].data);
          // // 离心速度
          // this.init_chart("#mychart-dom-bar3", initChart, froSpeedTableData.time, froSpeedTableData.list[0].data);
          // // 功率时间
          // this.init_chart("#mychart-dom-bar4", initChart, speedTableData.time, speedTableData.list[0].data);
          // // 向心加速度
          // this.init_chart("#mychart-dom-bar5", initChart, toAccTableData.time, toAccTableData.list[0].data);
          // // 离心加速度
          // this.init_chart("#mychart-dom-bar6", initChart, froAccTableData.time, froAccTableData.list[0].data);
          this.modalShow = true;
        }
      });
    },
    znData(params) {
      API_Member.deviceF035Data({
        deviceRecordId: params.id,
        userId: params.memberId,
      }).then((res) => {
        if (res.code == 200) {
          let data = res.data;
          console.log(data);
          let { timeData, statData, trainData, coastData } = data;
          let time = [];
          for (let i = 0; i < timeData.length; i++) {
            time.push(this.timeFormer(timeData[i]));
          }
          // console.log(time);
          let znSpeadDetails = {
            maxSpeedIn: data.maxSpeedIn,
            maxSpeedOut: data.maxSpeedOut,
            avgSpeedIn: data.avgSpeedIn,
            avgSpeedOut: data.avgSpeedOut,
            speadData: {
              time,
              list: {
                data: [
                  { name: "向心", data: data.speadInData },
                  { name: "离心", data: data.speadOutData },
                ],
              },
            },
          };
          let znPowerDetails = {
            maxPower: data.maxPower,
            avgPower: data.avgPower,
            powerData: {
              time,
              list: data.powerData,
            },
          };
          let znPowerCostDetails = {
            maxEnerge: data.maxEnerge,
            energeData: {
              time,
              list: data.energeData,
            },
          };
          let znRfdDetails = {
            maxRfd: data.maxRfd,
            rfdData: {
              time,
              list: data.rfdData,
            },
          };
          let arr = [];
          for (const key in coastData) {
            let obj = {
              name: key,
              value: coastData[key],
            };
            arr.push(obj);
          }
          let znSpendTime = {
            data: arr,
          };
          this.znSpeadDetails = znSpeadDetails;
          this.znPowerDetails = znPowerDetails;
          this.znPowerCostDetails = znPowerCostDetails;
          this.znRfdDetails = znRfdDetails;
          this.trainData = trainData;
          this.znSpendTime = znSpendTime;
          this.statData = statData;
          this.modalShow = true;
        }
      });
    },
    timeFormer(numb) {
      let time = new Date(numb);
      let HH = time.getHours();
      let mm = time.getMinutes();
      HH < 10 && (HH = "0" + HH);
      mm < 10 && (mm = "0" + mm);
      return HH + ":" + mm;
    },
  },
};
</script>
<style scoped lang="less">
.ant-advanced-search-form {
  padding: 24px;
  // border-radius: 6px;
}

::v-deep.ant-table-body table {
  border: none;
}

.detail_modal .modal_content {
  height: 80vh;
}

.chart_modal_content {
  width: 80%;
  margin: 0 auto;
}

.modal_content {
  height: 400px;
  overflow-y: scroll;

  &::-webkit-scrollbar {
    width: 0;
  }

  .ant-form-item {
    margin-bottom: 0;
  }

  .header {
    text-align: left;
    border-left: 4px solid #1890ff;
    color: var(--text-color);
    padding-left: 8px;
  }

  .exciting_total_list {
    .exciting_total_item {
      font-size: 14px;
      font-weight: 700;
      color: var(--text-color);
      width: 180px;
      height: 90px;
      margin-right: 33px;
      border-radius: 15px;

      &:last-child {
        margin-right: 0;
      }

      .exciting_num {
        font-size: 20px;
      }
    }
  }

  .color {
    color: var(--text-color);
  }

  .temBar {
    height: 40px;
    // background: #141937;
    border-radius: 4px;
    margin-bottom: 8px;
  }
}

.data_userInfo {
  width: 100%;
  display: flex;
  position: relative;
  height: 120px;
  border-radius: 4px;
  margin-top: 20px;
  margin-bottom: 20px;
  color: #fff;
  border: 1px solid rgba(255, 255, 255, .1);

  .user {
    width: 120px;
    flex-wrap: wrap;
    display: flex;
    justify-content: center;
    padding-top: 20px;
    border-right: 1px solid rgba(255, 255, 255, 0.1);

    .avatar {
      width: 50px;
      height: 50px;
      border-radius: 100px;
      display: inline-block;
      position: relative;
      overflow: hidden;
      line-height: 0;
      .el-avatar {
        width: 100%;
        height: 100%;
      }
    }

    .name {
      width: 100%;
      color: #fff;
      line-height: 20px;
      vertical-align: top;
      text-align: center;
      font-size: 12px;
    }
  }

  .base {
    display: flex;
    align-items: center;
    padding-left: 20px;

    .row_th {
      width: 200px;

      .odd {
        padding-bottom: 10px;
        font-size: 12px;
      }
    }
  }

  .date_bored {
    position: absolute;
    top: 50%;
    right: 20px;
    transform: rotate(-20deg);
    width: 70px;
    height: 70px;
    border-radius: 100px;
    margin-top: -40px;
    border: 1px solid #1890ff;
    color: #1890ff;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;

    &.done {
      border-color: #fff;
      color: #fff;
    }

    .sut {
      width: 100%;
      font-size: 12px;
      height: 20px;
      text-align: center;
    }

    .time {
      width: 100%;
      font-size: 12px;
      height: 20px;
      text-align: center;
    }
  }
}

.data_echart {
  position: relative;

  .chart_y_name {
    position: absolute;
    top: 36px;
    color: #fff;
    z-index: 99;
    left: 20px;
    font-size: 12px;
  }
}
.devicePanel {
  ::v-deep .el-dialog__body {
    max-height: 80vh;
  }
 
}
</style>
